export const CHANGE_LANGUAGE_REQUEST = "CHANGE_LANGUAGE_REQUEST";
export const CHANGE_LANGUAGE_SUCCESS = "CHANGE_LANGUAGE_SUCCESS";
export const CHANGE_LANGUAGE_FAILURE = "CHANGE_LANGUAGE_FAILURE";

export const LANGUAGE_OPTIONS = [
  { key: "English", text: "English", value: "English" }
];
